<template>
  <base-widget title="Groups">
    <base-list
      v-slot:default="{item}"
      :items="groups"
    >
      <base-cell v-slot:default="{hover}">
        <base-avatar
          :size="27"
          class="mx-3"
          :username="item.name"
        />
        <base-text size="m">
          {{ item.name }}
        </base-text>
        <base-button
          v-if="hover"
          class="rm-btn ml-auto p-0 text-muted"
          text
        >
          Remove
        </base-button>
      </base-cell>
    </base-list>
  </base-widget>
</template>
<script>
export default {

  name: 'ClientGroups',
  props: {
    customer: {
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    groups() {
      if (!this.customer.member_of) return [];
      return this.customer.member_of.filter((item) => !(item.is_supergroup));
    },
  },
};
</script>
<style lang="css" scoped>
</style>
